import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@treatwell/treatwell-aura';
import { FormContextData, useFormContext } from '../../state';
import { useValidation } from './helpers/use-validation';

const MAX_LENGTH = 80;
export const lastNameRegex = /^[A-ZÀ-ÿ-,a-z. ]+$/;

export function LastName(): JSX.Element {
  const { t } = useTranslation('input', { keyPrefix: 'lastName' });
  const {
    data: { lastName },
    setData,
  } = useFormContext();

  const hasValue = useCallback(
    (data: FormContextData) => (data.lastName ? null : 'LastName is empty'),
    [],
  );

  const validate = useCallback((data: FormContextData) => {
    if (!data.lastName) {
      return 'LastName is empty';
    }
    if (!data.lastName.match(lastNameRegex)) {
      return 'LastName is invalid';
    }
    if (data.lastName.length > MAX_LENGTH) {
      return 'LastName is too long';
    }
    return null;
  }, []);

  const extraInputProps = useValidation(t, hasValue, validate);

  const onValueChange = useCallback(
    (value: string) => {
      setData(current => ({ ...current, lastName: value }));
    },
    [setData],
  );

  return (
    <Input
      id="last-name"
      type="text"
      label={t('label')}
      value={lastName}
      onValueChange={onValueChange}
      autoComplete="family-name"
      maxLength={MAX_LENGTH}
      {...extraInputProps}
    />
  );
}
